import { InjectionToken } from '@angular/core';
import { AbstractControlDirective, NgControl } from '@angular/forms';
import { Observable } from 'rxjs';

export type FormFieldAppearance = 'outline' | 'fill';

export type FormFieldColor = 'primary' | 'accent' | 'warn';

/** `float` animates onto the outline; `above` is static, leaving no notch. */
export type FormFieldLabelPosition = 'float' | 'above';

export interface AppFormFieldDefaultOptions {
  labelPosition?: FormFieldLabelPosition;
}

/**
 * Defaults for every field under the injector that provides it, including those
 * rendered by child components - a screen opts in without threading an input.
 */
export const APP_FORM_FIELD_DEFAULT_OPTIONS =
  new InjectionToken<AppFormFieldDefaultOptions>(
    'APP_FORM_FIELD_DEFAULT_OPTIONS'
  );

/** DI token + contract for controls inside `<app-form-field>`; same shape as Material's `MatFormFieldControl`. */
export abstract class FormFieldControl<T> {
  abstract value: T | null;
  abstract readonly stateChanges: Observable<void>;
  abstract readonly id: string;
  abstract readonly placeholder: string;
  abstract readonly ngControl: NgControl | AbstractControlDirective | null;
  abstract readonly focused: boolean;
  abstract readonly empty: boolean;
  abstract readonly shouldLabelFloat: boolean;
  abstract readonly required: boolean;
  abstract readonly disabled: boolean;
  abstract readonly errorState: boolean;
  abstract readonly controlType?: string;
  abstract readonly autofilled?: boolean;
  abstract readonly userAriaDescribedBy?: string;
  abstract setDescribedByIds(ids: string[]): void;
  abstract onContainerClick(event: MouseEvent): void;
}
